import React, { useRef, useEffect, useState } from "react";
import { useGLTF } from "@react-three/drei";
import { useFrame, useThree } from "@react-three/fiber";
import { a } from "@react-spring/three";
import * as THREE from "three";
import ModelScene from "../accests/3d/ploshadka_n.glb";
import gsap from "gsap";

const Ploshadka_n = (props) => {
  const { nodes, materials } = useGLTF(ModelScene);
  const [hovered, hover] = useState(false);

  const colorChange = async () => {
    let key = Object.keys(materials);
    if (props.fog && !hovered)
      key.forEach((element) => {
        if (element != "окна" && element != "выступы")
          gsap.to(materials[element].emissive, 0.3, {
            r: 0.5,
            g: 0.5,
            b: 0.5,
          });
      });
    else {
      key.forEach((element) => {
        if (element != "окна" && element != "выступы")
          gsap.to(materials[element].emissive, 0.3, {
            r: 0,
            g: 0,
            b: 0,
          });
      });
    }
  };
  useEffect(() => {
    colorChange();
  }, [props.fog]);
  const modelRef = useRef();
  return (
    <a.group
      {...props}
      ref={modelRef}
      
    >
      <group rotation={[0, -0.274, 0]} scale={[0.225, 0.024, 0.149]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube017.geometry}
          material={materials.клумба}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube017_1.geometry}
          material={materials.ВЕРЕВКИ}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube017_2.geometry}
          material={materials.качель}
        />
      </group>
      <group rotation={[0, 1.498, 0]} scale={[0.225, 0.024, 0.149]}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube062.geometry}
          material={materials.клумба}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube062_1.geometry}
          material={materials.ВЕРЕВКИ}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube062_2.geometry}
          material={materials.качель}
        />
      </group>
      <group position={[-47.644, 1.237, -51.306]} scale={0.761}>
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube064.geometry}
          material={materials.печосница}
        />
        <mesh
          castShadow
          receiveShadow
          geometry={nodes.Cube064_1.geometry}
          material={materials.песок}
        />
      </group>
    </a.group>
  );
};

export default Ploshadka_n;
